import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ConnectionTestResponse } from "@/services/reportExportService";

@Component
export default class ConnectionTestMixin extends Vue {
    protected testing = false;
    protected testResult: ConnectionTestResponse | null = null;

    protected async performConnectionTest(
        testFn: () => Promise<ConnectionTestResponse>
    ): Promise<void> {
        this.testing = true;
        this.testResult = null;

        try {
            this.testResult = await testFn();
        } catch (error: any) {
            this.testResult = {
                success: false,
                message: error.response?.data?.message ||
                    error.message ||
                    "Connection test failed"
            };
        } finally {
            this.testing = false;
        }
    }

    protected clearTestResult(): void {
        this.testResult = null;
    }
}
